// @flow

import styled from 'styled-components';

export default styled.div`
  direction: ltr;
  &.rtl {
    direction: rtl;
  }
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  img {
    width: 120px;
    height: auto;
  }
  h3 {
    margin: 15px 20px 40px;
    color: #fff;
    text-align: center;
    font-size: 16px;
  }
  & > .appsLink {
    color: #fff;
    text-align: center;
    background: rgba(255,255,255,.2);
    border-radius: 5px;
    padding: 3px 10px;
    & > * {
      display: inline-block;
      margin: .3rem;
      font-size: 1.2rem;
      color: #ffc13b;
    }
  }
`;
